import {Component, DestroyRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {
  OrderType,
  SupplierPluginsNames,
  UserPayers,
  UserSuppliers,
  UserSuppliersAndOutlets
} from "../../../../app-shared/models/supplier-outlet.model";
import {SupplierOutletService} from "../../../../app-shared/services/supplier-outlet.service";
import {ObjectForeSearch} from "../../../../catalog/models/search.model";
import {Router} from "@angular/router";
import {CartService} from "../../../../app-shared/services/cart.service";
import {CatalogService} from "../../../../catalog/catalog.service";
import {SearchService} from "../../../../app-shared/services/search-service";
import {PriorityListType} from "../../../../catalog/models/product.model";
import {Subject} from "rxjs";
import {BreadCrumbsDynamicService} from "../../../../app-shared/services/bread-crumbs.service";
import {takeUntil} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "src/environments/environment";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-change-outlet-core',
    templateUrl: './change-outlet-core.component.html',
    styleUrls: ['./change-outlet-core.component.scss'],
    standalone: false
})
export class ChangeOutletCoreComponent implements OnInit {
  @Input() mobile: boolean;
  @Input() isLoginSuperBusinessAdminOrBusinessAdmin: boolean;
  @Output() closeAction = new EventEmitter<boolean>();

  formSuppliersAndOutlets: UntypedFormGroup;
  userSuppliersAndOutlets: Array<UserSuppliersAndOutlets>;
  suppliers: Array<UserSuppliers>;
  payers: Array<UserPayers>;
  selectedSupplierId: number;
  isTare: boolean;
  readonly OrderTypes = OrderType;
  readonly priorityListType = PriorityListType;

  virtualCurrencyName: any;
  private readonly destroyRef = inject(DestroyRef);

  constructor(private supplierOutletService: SupplierOutletService,
              private fb: UntypedFormBuilder,
              private router: Router,
              private cartService: CartService,
              private catalogService: CatalogService,
              private searchService: SearchService,
              private breadCrumbsService: BreadCrumbsDynamicService,
              private translate: TranslateService,) {
    this.virtualCurrencyName = {
      virtualCurrencyName: this.supplierOutletService.getVirtualCurrencyName(),
    };
  }

  ngOnInit(){
    this.isTare = this.router.url.includes(
      this.OrderTypes[this.OrderTypes.tare]
    );
    this.buildFormSuppliersAndOutlets();
    this.changeFormValue();
    this.detectSetFormValue();
    this.checkChangeLanguage();
    this.detectChangeOutletData();
  }

  private buildFormSuppliersAndOutlets() {
    const isTare = this.router.url.includes(
      this.OrderTypes[this.OrderTypes.tare]
    );
    const outletId = this.supplierOutletService.getUserSelectedSupplierAndOutlet().outletId;
    const supplierId = this.supplierOutletService.getUserSelectedSupplierAndOutlet().supplierId;

    this.supplierOutletService.getUserSuppliersAndOutlets()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
      (userSuppliersAndOutlets) => {

        this.initOutletOptions(userSuppliersAndOutlets, isTare);

        this.suppliers = this.supplierOutletService.getUserSuppliersByOutletId(
          this.userSuppliersAndOutlets,
          outletId
        );
        this.payers = this.supplierOutletService.getUserPayersBySelectedSupplier();
        this.formSuppliersAndOutlets = this.fb.group({
          supplierId: [supplierId],
          outletId: [outletId],
          payerId: [this.payers.length ? this.payers[0].payerId : null]
        });
      },
      () => {
        this.userSuppliersAndOutlets = [];
        this.formSuppliersAndOutlets = this.fb.group({
          supplierId: [],
          outletId: [],
        });
      }
    )
  }

  initOutletOptions(userSuppliersAndOutlets, isTare: boolean): void {
    const filteredUserSuppliersAndOutlets: Array<UserSuppliersAndOutlets> =
      isTare ? [] : userSuppliersAndOutlets;
    if (isTare) {
      userSuppliersAndOutlets.forEach((so) => {
        const supplierOutletCode = so.suppliers.find(s => s.outletId == so.outletId).supplierOutletCode;
        const sapCode = !!environment['useSapCodeInOutletDropDown'] ? `${this.translate.instant('sap-name')}: ${supplierOutletCode}` : '';
        so.outletName = `${so.outletName}, ${so.address} ${sapCode}`;
        so.suppliers.forEach((s) => {
          s.supplierOutletPlugins.forEach((ss) => {
            if (
              ss.pluginName === SupplierPluginsNames.IsPackingReturn &&
              ss.pluginValue
            ) {
              const filteredUserSuppliersAndOutletsIndex =
                filteredUserSuppliersAndOutlets.findIndex(
                  (f) => f.outletId === so.outletId
                );
              if (
                !filteredUserSuppliersAndOutlets[
                  filteredUserSuppliersAndOutletsIndex
                  ]
              ) {
                filteredUserSuppliersAndOutlets.push({
                  outletId: so.outletId,
                  outletName: so.outletName,
                  address: so.address,
                  currency: so.currency,
                  suppliers: [],
                });
              }
              filteredUserSuppliersAndOutlets[
              filteredUserSuppliersAndOutlets.length - 1
                ].suppliers.push(s);
            }
          });
        });
      });
    } else {
      userSuppliersAndOutlets.forEach((so) => {
        const supplierOutletCode = so.suppliers.find(s => s.outletId == so.outletId).supplierOutletCode;
        const sapCode = !!environment['useSapCodeInOutletDropDown'] ? `${this.translate.instant('sap-name')}: ${supplierOutletCode}` : '';
        so.outletName = `${so.outletName}, ${so.address }  ${sapCode} `;
      });
    }
    this.userSuppliersAndOutlets = filteredUserSuppliersAndOutlets;
  }

  changeFormValue() {
    this.formSuppliersAndOutlets
      .get('outletId')
      .valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((outletId) => {
      this.changeFormOutletValue(outletId);
    });
    this.formSuppliersAndOutlets
      .get('supplierId')
      .valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((supplierId) => {
      this.virtualCurrencyName = {
        virtualCurrencyName:
          this.supplierOutletService.getVirtualCurrencyName(
            supplierId,
            this.formSuppliersAndOutlets.get('outletId').value
          ),
      };
      this.selectedSupplierId = supplierId;
      if (!this.mobile) {
        this.changeFormSupplierValueAndReloadCatalog(supplierId);
      }
    });
  }
  changeFormOutletValue(outletId) {
    this.suppliers = this.supplierOutletService.getUserSuppliersByOutletId(
      this.userSuppliersAndOutlets,
      outletId
    );
    const prevSupplierValue =
      this.formSuppliersAndOutlets.get('supplierId').value;
    const supplier = this.suppliers.find(
      (item) => item['supplierId'] === prevSupplierValue
    );
    const supplierId = supplier
      ? supplier.supplierId
      : this.suppliers[0].supplierId;
    this.formSuppliersAndOutlets.get('supplierId').setValue(supplierId);
    this.setPayerValue();
  }

  setPayerValue() {
    this.payers = this.supplierOutletService.getUserPayersBySelectedSupplier();
    this.formSuppliersAndOutlets.get('payerId').setValue(this.payers.length ? this.payers[0].payerId : null);
  }

  changeFormSupplierValueAndReloadCatalog(supplierId) {
    this.supplierOutletService.getUserSuppliersAndOutlets()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: (data) => {
        this.breadCrumbsService.clearBreadCrumbs();
        const selectedSupplierByOutlet =
          this.supplierOutletService.getSupplierByOutletIdAndSupplierIdSelectedModel(
            supplierId,
            this.formSuppliersAndOutlets.get('outletId').value
          );
        this.supplierOutletService.changeSelectedSupplierAndOutlet(
          selectedSupplierByOutlet
        );
        // update credit limit for selected supplier and outlet
        this.cartService.creditLimitSubject.next(this.cartService.getCreditLimitBySupplierAndOutlet(
          selectedSupplierByOutlet.supplierId,
          selectedSupplierByOutlet.outletId)
        );
        //
        this.catalogService.reloadCatalogForSelectedUserSupplierAndOutlet(
          () => {},
          () => {
            this.searchService.hideSearch();
            this.searchService.disabled = false;
            this.catalogService.getProducts(false, {
              prodClassificationId: 1,
              filterForPrice: [
                {
                  plType: this.catalogService.checkProductCatalog()
                    ? this.priorityListType.allLists
                    : this.priorityListType.tare,
                  promoId: 0,
                },
              ],
              productWithFilter: [],
              breadCrumbs: [],
              searchModel: {
                objectForeSearch: ObjectForeSearch.IsProductName,
                values: [],
              },
              srtType: 1,
              skip: 0,
              take: 10,
            });
          }
        );
      },
    });
  }

  detectSetFormValue() {
    this.catalogService.changeSuppierAndOutlet
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(chang => {
        const outletId = this.supplierOutletService.getUserSelectedSupplierAndOutlet().outletId;
        const supplierId = this.supplierOutletService.getUserSelectedSupplierAndOutlet().supplierId;
        const formOutletId = this.formSuppliersAndOutlets.get('outletId').value
        const formSupplierId = this.formSuppliersAndOutlets.get('supplierId').value
        if (outletId !== formOutletId) {
          this.formSuppliersAndOutlets.get('outletId').setValue(outletId, { emitEvent: false })
        }
        if (supplierId !== formSupplierId) {
          this.formSuppliersAndOutlets.get('supplierId').setValue(supplierId, { emitEvent: false });
        }
        this.supplierOutletService.getUserSuppliersAndOutlets()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(userSuppliersAndOutlets => {
            this.initOutletOptions(userSuppliersAndOutlets, this.isTare)
          })
      })
  }

  detectChangeOutletData() {
    this.supplierOutletService.changeOutletData
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(chang => {
        this.supplierOutletService.getUserSuppliersAndOutlets()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(userSuppliersAndOutlets => {
            this.initOutletOptions(userSuppliersAndOutlets, this.isTare)
          })
      })
  }

  clickClose() {
    this.closeAction.emit(true);
  }

  applyChanges() {
    if (this.selectedSupplierId) {
      this.changeFormSupplierValueAndReloadCatalog(this.selectedSupplierId);
    }
    this.clickClose();
  }

  getPanelClass() {
    return this.mobile ? 'suppliers-outlets-panel mobile' : 'suppliers-outlets-panel';
  }

  checkChangeLanguage() {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.payers = this.supplierOutletService.getUserPayersBySelectedSupplier();
      })
  }

}
